import useCertificateHelper from 'hooks/useCertificateHelper';

import Label from '../Label';
import * as Styled from './Detail.styles';

interface DetailProps {
  label: string;
  value: any;
}

const Detail = ({ label, value }: DetailProps) => {
  const { defaultValue } = useCertificateHelper();

  return (
    <Styled.Container>
      <Label>{label}</Label>
      <Styled.Value>{value || defaultValue}</Styled.Value>
    </Styled.Container>
  );
};

export default Detail;
